import React from 'react'
import { Button } from '@chilecompra/react-kit/components'
import { deleteCookie } from '@chilecompra/react-kit'
import { PUBLIC_URL, REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import MenuTransversal from './MenuTransversal.container'
import PublicSection from '../../components/Security/PublicSection'
import { Container, Item, Logo, LogoLink, Root } from './Header.styles'

/**
 * The Header's container.
 */
const Header = () => {
  const handleClickHome = (event, isPrivate) => {
    event.preventDefault()
    deleteCookie('access_token')
    if (isPrivate) {
      window.open(`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`, '_top')
      return
    }
    location.href = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home`
  }
  return (
    <PublicSection>
      <Root>
        <MenuTransversal />
        <Container direction="row" justifyContent="space-between">
          <Item width="auto">
            <LogoLink href={`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home`} target="_top">
              <Logo alt="Chilecompra" src={`${PUBLIC_URL}/assets/images/logo_mercadopublico.svg`} />
            </LogoLink>
            <Button margin="10px 0 0 0" color="default" variant="outlined" onClick={event => handleClickHome(event)}>
              Volver al inicio
            </Button>
          </Item>
        </Container>
      </Root>
    </PublicSection>
  )
}

export default Header
